import { EnergyUsage } from './vehicleInfo/energyUsage/energy-usage.model';
import { UsageLimit } from './vehicleInfo/usageLimit/usage-limit.model';
import { VehicleConfig } from './vehicleInfo/vehicleConfig/vehicle-config.model';
import { VehicleUsage } from './vehicleInfo/vehicleUsage/vehicle-usage.model';

export class VehicleInformation {
	id!: number;
	vehicleUsage!: VehicleUsage;
	vehicleConfig!: VehicleConfig;
	energyUsage!: EnergyUsage;
	usageLimit!: UsageLimit;
}
